import { cloneDeep } from 'lodash';

const SET_HEADER_DETAILS_OPEN = 'SET_HEADER_DETAILS_OPEN';
const SET_HEADER_DETAILS_OPEN_FALSE = 'SET_HEADER_DETAILS_OPEN_FALSE';

const initialStateHeaderDetailsOpen = false;

export default function reducer(state = cloneDeep(initialStateHeaderDetailsOpen), action) {
	switch (action.type) {
		case SET_HEADER_DETAILS_OPEN:
			return true;
		case SET_HEADER_DETAILS_OPEN_FALSE:
			return false;
		default:
			return state;
	}
}

export function setHeaderDetailsOpen(){
  return { type: SET_HEADER_DETAILS_OPEN }
}

export function setHeaderDetailsOpenFalse(){
  return { type: SET_HEADER_DETAILS_OPEN_FALSE }
}


// WEBPACK FOOTER //
// ./src/modules/header_details_open.js